module.exports = __webpack_public_path__ + "img/train-6.fe0d560d.jpg";